export enum EPoolingApiUrl {
  landing = '/api/landings/:identifier',
}
